import { HeaderMode, FooterMode } from './index';
var HeaderFooterSettingsBuilder = /** @class */ (function () {
    function HeaderFooterSettingsBuilder() {
        this.headerFooterSettings = {
            header: {
                mode: HeaderMode.DEFAULT,
                html: ''
            },
            footer: {
                mode: FooterMode.DEFAULT,
                html: ''
            }
        };
    }
    HeaderFooterSettingsBuilder.prototype.withHeader = function (header) {
        this.headerFooterSettings.header = header;
        return this;
    };
    HeaderFooterSettingsBuilder.prototype.withFooter = function (footer) {
        this.headerFooterSettings.footer = footer;
        return this;
    };
    HeaderFooterSettingsBuilder.prototype.build = function () {
        return this.headerFooterSettings;
    };
    return HeaderFooterSettingsBuilder;
}());
export { HeaderFooterSettingsBuilder };
//# sourceMappingURL=header-footer-settings.builder.js.map